// extracted by mini-css-extract-plugin
module.exports = {"container":"Dashboard_container__Cpf0x","buttonContainer":"Dashboard_buttonContainer__1UrHm"};